import { FC, PropsWithChildren, ReactNode, createContext, memo, useContext, useMemo } from "react";
import { Settings } from "../types/settings";
import useSettingsProvider from "../hooks/useSettingsProvider";
import { LoadingAnimation } from "@/components/LoadingAnimation";
import _ from "lodash"

interface ISettingsProviderProps extends PropsWithChildren {
  debugSettings?: Partial<Settings>;
}

const SettingsProvider: FC<ISettingsProviderProps> = ({
  children, debugSettings
}) => {
  
  const parentSettings = useContext(SettingsProviderContext);

  const mergedSettings = useMemo(() => {
    // First settings must be always a fully typed Settings object
    if (parentSettings === null) {
      return debugSettings as (Settings | null);
    }

    // If a child of parent settings, merge them
    return _.merge({}, parentSettings, debugSettings);
  }, [parentSettings, debugSettings]);

  if (debugSettings && mergedSettings) {  
    return <SettingsProviderContext.Provider value={mergedSettings}>
      {children}
    </SettingsProviderContext.Provider>
  }
  
  const { settings } = useSettingsProvider();

  return <SettingsProviderContext.Provider value={settings.privateData ?? settings.publicData}>
    {!settings.loaded && settings.isFetching && <LoadingAnimation />}
    {settings.loaded && !settings.error && children}
    {settings.loaded && settings.error && <div>Error fetching settings</div>}
  </SettingsProviderContext.Provider>
}

export default SettingsProvider;

export const SettingsProviderContext = createContext<null | Settings>(null);
